define('module/MenuModule',['require','marionette','model/MenuModel','view/module/menu/MenuListView','collection/MenuCollection'],function (require) {
	
	var Marionette = require('marionette');
	var MenuModel = require('model/MenuModel');
	//var MenuView = require('view/module/MenuView');
    var MenuListView = require('view/module/menu/MenuListView');
    var MenuCollection = require('collection/MenuCollection');

	/**
	 * Controller for menu module
	 * 
	 * @class MenuModule
	 */
	return Marionette.Object.extend({
		
		_region: null,
		_model: null,

		/**
		 * Inits instance
		 */
		initialize: function () {
			this._region = this.getOption('layout').getMenuRegion();
			this._footerRegion = this.getOption('layout').getFooterMenuRegion();

			var menuList = Config.getInstance().getOption('menu');

			if(menuList && menuList.length) {
                this._collection = new MenuCollection(menuList);
            } else {
                this._collection = new MenuCollection();
                this._collection.load();
			}

			//this._initMenu();
			this._initListView();

		},

        /**
         * Initializes list view
         *
         * @private
         */
        _initListView: function () {
			this._region.show(new MenuListView({
				collection: this._collection
			}));

			this._footerRegion.show(new MenuListView({
				collection: this._collection,
				is_footer: true,
			}));
        },
		
		/**
		 * Init menu model, view and subscribe to router event
		 */
/*		_initMenu: function () {
			this._model = new MenuModel();
			
			this._region.show(new MenuView({
				model: this._model
			}));
			
			var instance = this;
			Backbone.history.on('route', function (route) {
	    		instance._model.set('active_menu_item', route.getOption('menuItem'));
	    	});
		}*/
		
	});
	
});
